var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.benefits),function(benefit,index){return _c('v-list-item',{key:index},[_c('v-list-item-title',[_c('v-icon',{staticClass:"mr-2 text--darken-1 font-weight-bold",attrs:{"color":_vm.iconColor ? _vm.iconColor : 'grey',"size":"26"}},[_vm._v(" done ")]),_vm._v(" "+_vm._s(benefit)+" ")],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }